import { Directive, ElementRef, Renderer2, effect, inject, input } from '@angular/core';
import { ProductIntegrationStatus } from '../../../../enums';

type ProductStatusConfig = {
  color: string;
  icon: string;
};

@Directive({
  selector: '[aionzProductStatus]',
  standalone: true
})
export class ProductStatusDirective {
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private renderer = inject(Renderer2);
  public status = input.required<ProductIntegrationStatus>({
    alias: 'aionzProductStatus'
  });

  private readonly statusToConfig: Record<ProductIntegrationStatus, ProductStatusConfig> = {
    [ProductIntegrationStatus.INTEGRATION_FAILED]: {
      color: '#D83C38',
      icon: 'error'
    },
    [ProductIntegrationStatus.PARTIALLY_INTEGRATED]: {
      color: '#9A6704',
      icon: 'warning'
    },
    [ProductIntegrationStatus.SUCCESSFULLY_INTEGRATED]: {
      color: '#33A745',
      icon: 'check_circle'
    }
  };

  constructor() {
    effect(() => {
      this.applyStatus(this.status());
    });
  }

  private applyStatus(status: ProductIntegrationStatus): void {
    const iconEl = this.elementRef.nativeElement.querySelector('mat-icon');
    const config = this.statusToConfig[status];

    if (!config) {
      this.renderer.setStyle(this.elementRef.nativeElement, 'color', '#232325');
      if (iconEl) this.renderer.setStyle(iconEl, 'display', 'none');
      return;
    }

    this.renderer.setStyle(this.elementRef.nativeElement, 'color', config.color);
    if (!iconEl) return;

    this.renderer.setStyle(iconEl, 'display', 'inline-flex');
    this.renderer.setProperty(iconEl, 'textContent', config.icon);
  }
}
